import request from 'utils/request';

const PREFIX = '/api/enum/';

export const ENUM_KEY = {
  // 账单枚举
  BILLING: 'billing',
};

export function getEnums(key) {
  return request({
    url: PREFIX + key,
    method: 'get',
    query: key,
  });
}
